import _styled from "@emotion/styled/base";
import { css } from '@emotion/react';
import StyledButton from '../../button/button-new.styles';
import { colors, rem, rgba, spacing, utilityStyles } from '../../../styles';
var defaultStyles = function defaultStyles(_ref) {
  var disabled = _ref.disabled;
  var defaultShadow = rem(0, 2, 6, 0) + ' ' + rgba(colors.blackDeep, 0.2);
  return /*#__PURE__*/css("background:", colors.navy_500, ";box-shadow:", defaultShadow, ";color:", colors.white, ";padding:", rem(0, 12), ";", disabled ? /*#__PURE__*/css("&[disabled]{background:", colors.coolGray_500, ";color:", colors.coolGray_200, ";min-height:", rem(spacing.spacingActionHeightXs), ";opacity:1;}" + (process.env.NODE_ENV === "production" ? "" : ";label:defaultStyles;")) : /*#__PURE__*/css("&:hover,&[aria-selected='true']{background:", colors.lightBlue_100, ";color:", colors.navy_500, ";}&:focus{box-shadow:", rem(0, 0, 0, 4), " ", colors.lightBlue_500, ";}&:active{background:", colors.white, ";box-shadow:", defaultShadow, ";color:", colors.navy_500, ";}" + (process.env.NODE_ENV === "production" ? "" : ";label:defaultStyles;")), " svg{margin-left:", rem(8), ";margin-right:0;path{fill:", colors.lightBlue_500, ";}}" + (process.env.NODE_ENV === "production" ? "" : ";label:defaultStyles;"));
};
var StyledMultiSelectChip = /*#__PURE__*/_styled(StyledButton, process.env.NODE_ENV === "production" ? {
  target: "e2wjm410"
} : {
  target: "e2wjm410",
  label: "StyledMultiSelectChip"
})(defaultStyles, utilityStyles);
StyledMultiSelectChip.defaultProps = {
  shape: 'pill',
  size: 'xs',
  type: 'button'
};
export default StyledMultiSelectChip;